import { getFullNameUser } from 'Helpers/avatarHelper';
export default (staffList, ownerId = null) => {
    if (!staffList) {
        return [];
    }
    staffList = staffList.sort((a, b) => {
        const fullNameA = getFullNameUser(a).toLowerCase();
        const fullNameB = getFullNameUser(b).toLowerCase();
        if (fullNameA > fullNameB) {
            return 1;
        }
        if (fullNameA < fullNameB) {
            return -1;
        }
        return 0;
    });
    if (ownerId) {
        const ownerIndex = staffList.findIndex((staff) => staff.id === ownerId);
        const owner = staffList[ownerIndex];
        if (ownerIndex !== -1) {
            staffList.splice(ownerIndex, 1);
            staffList.unshift(owner);
        }
    }
    return staffList;
};
